import React from 'react';
import ModuleImagePage from '../shared/ModuleImagePage.jsx';

const Demand = () => <ModuleImagePage moduleKey="demand" />;

export default Demand;
